import React, { useMemo, useEffect } from 'react';
import { Box } from '@wix/design-system';
import type { Section } from '@wix/app-market-services';
import { Placement } from '@wix/app-market-services';
import {
  useServices,
  useSiteContext,
  QueryDecorator,
  homePageId,
  useEssentials,
} from '@wix/app-market-core';
import { AppsSectionsSkeleton } from '../../components/apps-sections-skeleton';
import { HomePageSection } from './home-page-section';

export function HomePageSections({ onLoad }: { onLoad: () => void }) {
  const { metaSiteId } = useSiteContext();
  const services = useServices();

  return (
    <QueryDecorator
      queryFn={async () => {
        const { sections } =
          await services.appMarketClientAggregator.getDynamicSections({
            placement: Placement.HOME_PAGE,
            isMetaSiteId: !!metaSiteId,
          });

        return sections;
      }}
      queryKey={homePageId}
    >
      {({ data: sections, isLoading }) =>
        isLoading ? (
          <AppsSectionsSkeleton rows={1} boxCount={4} />
        ) : (
          <Sections onLoad={onLoad} sections={sections ?? []} />
        )
      }
    </QueryDecorator>
  );
}

function Sections({
  sections,
  onLoad,
}: {
  sections: Section[];
  onLoad: () => void;
}) {
  const { marketWatch } = useEssentials();

  useMemo(() => onLoad(), []);

  useEffect(() => {
    marketWatch.monitor(homePageId).transaction('sections-count').start();
    if (sections.length > 4) {
      marketWatch.monitor(homePageId).transaction('sections-count').finish();
    }
  }, []);

  return sections.map((section, index) => (
    <Box key={index} direction="vertical" marginBottom="30px">
      <HomePageSection section={section} index={index} />
    </Box>
  ));
}
